import React from "react";
import { ArrowRightOnRectangleIcon } from "@heroicons/react/24/outline";
import SettingsSection from "../fields/SettingsSection";
import DangerZone from "../profile/DangerZone"

/**
 * AccountSection - Sign out and future account actions
 *
 * Currently provides a Sign Out button.
 * Designed for future expansion (e.g., Delete Account will move here).
 *
 * @param {function} onLogout - Handler called when user confirms sign out
 */
export default function AccountSection({ onLogout, onShowDelete }) {
  return (
    <SettingsSection
      id="account"
      title="Account"
      icon={
        <ArrowRightOnRectangleIcon className="h-5 w-5 text-primary" />
      }
    >
      <DangerZone onDelete={onShowDelete} />
      <div className="flex flex-col gap-4">
        <p className="text-sm text-text-secondary">
          Sign out of your Traces account on this device.
        </p>
        <button
          type="button"
          onClick={onLogout}
          className="inline-flex items-center gap-2 self-center sm:self-start px-4 py-2.5 rounded-xl border border-border text-text-primary hover:bg-red-50 dark:hover:bg-red-950/20 transition-colors text-sm font-medium"
        >
          <ArrowRightOnRectangleIcon className="h-4 w-4 text-destructive" />
          Sign Out
        </button>
      </div>

    </SettingsSection>
  );
}
